import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import {pxToRem} from '../../utils';

const StyledStep = styled(Step)(({theme}) => ({
  '& .MuiStepIcon-root': {
    color: theme.palette.warning.light,
    border: `${pxToRem(5)} solid ${theme.palette.white}`,
    borderRadius: '50%',
    fontSize: pxToRem(28),
  },
  '& .MuiStepLabel-root .Mui-completed': {
    color: theme.palette.secondary.main,
  },
  '& .MuiStepLabel-root .Mui-active': {
    color: theme.palette.secondary.main,
  },
  '& .MuiStepLabel-root .Mui-error': {
    color: theme.palette.error.main,
  },
  '& .MuiStepIcon-text': {
    display: 'none',
  },
}));
const CustomStepper = ({steps, completedIndex, errorIndex, errorMessage}) => {
  return (
    <Stepper alternativeLabel>
      {steps.map((label, index) => {
        const labelProps = {};
        if (errorIndex === index) {
          labelProps.optional = (
            <Typography variant="caption" color="error">
              {errorMessage}
            </Typography>
          );
          labelProps.error = true;
        }
        return (
          <StyledStep key={label} completed={index <= completedIndex ? true : false}>
            <StepLabel {...labelProps}>{label}</StepLabel>
          </StyledStep>
        );
      })}
    </Stepper>
  );
};

export default CustomStepper;
